import React from 'react'
import { isValid, parseISO, formatDistanceToNow } from 'date-fns'
import Date from './Date'
const PageListDate = (props) => {
    const lastMod = parseISO(props.lastmod)
    return (
        <>
            {(isValid(lastMod) && formatDistanceToNow(lastMod)) || null}&nbsp;ago
            <br />
            <small className="text-muted">
                <Date date={props.lastmod} format={'dd/MM/yyyy'} />
            </small>
        </>
    )
}

export default PageListDate
